// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"07feed99","801":"5303f933"}[chunkId] + ".css";
};